export default __webpack_public_path__ + "static/saab-668508d2e4c459fb79811af338e91923.png";